import VlalgValidPassword from './vlalgValidPassword'
import VlalgNewsletterBar from './vlalgNewsletterBar'

export default {
  components: {
    VlalgValidPassword,
    VlalgNewsletterBar
  }
}
